(function () {
  function create(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function arrowIcon() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "gg-lc8__ui-icon gg-lc8__ui-icon--arrow");
    svg.setAttribute("viewBox", "0 0 20 20");
    svg.setAttribute("aria-hidden", "true");
    svg.innerHTML = "<path d=\"M5 15 15 5M7 5h8v8\"></path>";
    return svg;
  }

  function initGuideFinder(root) {
    if (!root || root.dataset.lcSearchReady === 'true') return;
    root.dataset.lcSearchReady = 'true';

    var input = root.querySelector('[data-lc-search-input]');
    var results = root.querySelector('[data-lc-search-results]');
    if (!input || !results) return;

    var timer = 0;
    var controller = null;
    var activeIndex = -1;

    function closeResults() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function updateActive(items, nextIndex) {
      items.forEach(function (item) { item.classList.remove('is-active'); });
      activeIndex = nextIndex;
      if (activeIndex >= 0 && items[activeIndex]) {
        items[activeIndex].classList.add('is-active');
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      }
    }

    function render(query, articles) {
      results.innerHTML = '';
      var head = create('div', 'gg-lc8__result-head');
      head.append(create('span', '', 'Guide finder'), create('span', '', articles.length + (articles.length === 1 ? ' result' : ' results')));
      results.appendChild(head);

      if (!articles.length) {
        results.appendChild(create('div', 'gg-lc8__result-empty', 'No exact guide yet. Try a model, appliance, or solar topic.'));
      } else {
        articles.forEach(function (article, index) {
          var link = create('a', 'gg-lc8__result');
          link.href = article.url;
          link.setAttribute('role', 'option');
          link.append(
            create('span', 'gg-lc8__result-number', String(index + 1).padStart(2, '0')),
            create('strong', '', article.title),
            arrowIcon()
          );
          results.appendChild(link);
        });
      }

      var all = create('a', 'gg-lc8__result-all');
      all.href = '/search?q=' + encodeURIComponent(query) + '&type=article&options%5Bprefix%5D=last';
      all.append(create('span', '', 'View all Learning Center results'), arrowIcon());
      results.appendChild(all);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    function search() {
      var query = input.value.trim();
      if (query.length < 2) {
        closeResults();
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();
      var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var endpoint = rootPath + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources%5Btype%5D=article&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bfields%5D=title%2Cbody%2Ctag';

      fetch(endpoint, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Guide search failed');
          return response.json();
        })
        .then(function (data) {
          var resourceResults = data && data.resources && data.resources.results;
          var articles = resourceResults && resourceResults.articles ? resourceResults.articles : [];
          articles = articles.filter(function (article) {
            return article.url.indexOf('/blogs/learning-center/') === 0 || article.url.indexOf('/blogs/knowledge-base/') === 0;
          }).slice(0, 6);
          render(query, articles);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') closeResults();
        });
    }

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(search, 180);
    });

    input.addEventListener('keydown', function (event) {
      var items = Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
      if (event.key === 'Escape') {
        closeResults();
        return;
      }
      if (results.hidden || !items.length) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        updateActive(items, Math.min(activeIndex + 1, items.length - 1));
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        updateActive(items, Math.max(activeIndex - 1, 0));
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        window.location.assign(items[activeIndex].href);
      }
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeResults();
    });
  }

  function initPlannerCanvas(canvas) {
    if (!canvas || canvas.dataset.lcPlannerReady === 'true') return;
    canvas.dataset.lcPlannerReady = 'true';

    if (!window.matchMedia ||
        !window.matchMedia('(hover: hover) and (pointer: fine)').matches ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var frame = 0;

    canvas.addEventListener('pointermove', function (event) {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        var rect = canvas.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
        var y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
        canvas.style.setProperty('--lc8-pointer-x', x.toFixed(1) + '%');
        canvas.style.setProperty('--lc8-pointer-y', y.toFixed(1) + '%');
        canvas.style.setProperty('--lc8-shift-x', ((x - 50) * 0.045).toFixed(2) + 'px');
        canvas.style.setProperty('--lc8-shift-y', ((y - 50) * 0.035).toFixed(2) + 'px');
      });
    }, { passive: true });

    canvas.addEventListener('pointerleave', function () {
      canvas.style.setProperty('--lc8-pointer-x', '72%');
      canvas.style.setProperty('--lc8-pointer-y', '24%');
      canvas.style.setProperty('--lc8-shift-x', '0px');
      canvas.style.setProperty('--lc8-shift-y', '0px');
    });
  }

  function initCurriculum(curriculum) {
    if (!curriculum || curriculum.dataset.lcCurriculumReady === 'true') return;
    curriculum.dataset.lcCurriculumReady = 'true';

    var tabs = Array.prototype.slice.call(curriculum.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(curriculum.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || tabs.length !== panels.length) return;

    function select(index, focusTab) {
      tabs.forEach(function (tab, tabIndex) {
        var selected = tabIndex === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        panels[tabIndex].hidden = !selected;
      });
      if (focusTab) tabs[index].focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { select(index, false); });
      tab.addEventListener('keydown', function (event) {
        var next = index;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        select(next, true);
        tabs[next].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    });

    select(0, false);
  }

  function initBrandRail(root) {
    if (!root || root.dataset.lcBrandReady === 'true') return;
    root.dataset.lcBrandReady = 'true';

    var rail = root.querySelector('[data-lc-brand-rail]');
    var previous = root.querySelector('[data-lc-brand-prev]');
    var next = root.querySelector('[data-lc-brand-next]');
    if (!rail || !previous || !next) return;

    function step() {
      var card = rail.querySelector('.gg-lc8__brand');
      if (!card) return rail.clientWidth * 0.8;
      var styles = window.getComputedStyle(rail);
      return card.getBoundingClientRect().width + (parseFloat(styles.columnGap || styles.gap) || 12);
    }

    function update() {
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    }

    previous.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function removeLegacyBlogSection() {
    if (!document.querySelector(".gg-lc8")) return;

    document.querySelectorAll(".gg-main-blog-section").forEach(function (legacyBlog) {
      var section = legacyBlog.closest(".shopify-section");
      if (section) section.remove();
      else legacyBlog.remove();
    });
  }

  function init(root) {
    removeLegacyBlogSection();
    var scope = root || document;
    scope.querySelectorAll('[data-lc-search]').forEach(initGuideFinder);
    scope.querySelectorAll('[data-lc-planner-canvas]').forEach(initPlannerCanvas);
    scope.querySelectorAll('[data-lc-curriculum]').forEach(initCurriculum);
    scope.querySelectorAll('.gg-lc8__brands').forEach(initBrandRail);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

